var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#ED4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3019 17.3033C17.6273 16.9779 17.6273 16.4502 17.3019 16.1248L13.1776 12.0006L17.303 7.87523C17.6284 7.54979 17.6284 7.02215 17.303 6.69672C16.9775 6.37128 16.4499 6.37128 16.1245 6.69672L11.9991 10.8221L7.87376 6.69671C7.54832 6.37128 7.02069 6.37128 6.69525 6.69671C6.36981 7.02215 6.36981 7.54979 6.69525 7.87523L10.8206 12.0006L6.69638 16.1248C6.37094 16.4502 6.37094 16.9779 6.69638 17.3033C7.02182 17.6288 7.54946 17.6288 7.87489 17.3033L11.9991 13.1791L16.1233 17.3033C16.4488 17.6288 16.9764 17.6288 17.3019 17.3033Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleX);
export default __webpack_public_path__ + "static/media/circle-x.3532090b93233878dfde58915388d668.svg";
export { ForwardRef as ReactComponent };